import React, { useState, useEffect } from "react";
import {
  FormControl,
  FormErrorMessage,
  Textarea,
  InputGroup,
  InputRightElement,
  InputLeftElement,
  Input,
  Button,
  Link,
  Box,
  Center,
  useToast,
  Image,
} from "@chakra-ui/react";
import Parse from "parse";
import { useNavigate, useLocation } from "react-router-dom";
import "../../StylesPages/connexionpage.css";
import LinkedInOauth from "../LinkedInOauth";
import { Text } from "@chakra-ui/react";
import earth from "../../earth.png";
import fuse from "../../fuse.png";

//http://localhost:3000/?token=AQV5FpYhvORuUA9Hf9pZcjy6eMJms0_p7gH7iwOkXWJOmVN_KsXhs-Wf6BmszURAxiAgROKq5p4ODzh9j_o7RIYHD6v0vvR1o5lcMrnTsStUXhgL8qoRzI2tMRSaRxZOyeZf6AZ3q8nE08saZwyZ46TxwsT6um_kTTjHmFWoO-kOWRKBiN6fnlHp8L0Sfvc64Xgftg5ZMuf9Z7i4KmhmkOG_4-s2LYS_0UOuDWhIxQu1jUbNXh8HjyM9iaio3cdCLN6KBTPYtHbhvkhIWs2fUYI2rLuVo4wykDsRP0XWRc3px1u1Rv8LkewPtwnbFefRZy2axEl2p4pB2p4PMf4ElMl2-DjCzg&id=x9JSz-ks8d

function ConnexionPage({ showImageHeader }) {
  const search = useLocation().search;

  const toast = useToast();
  const onclick = async (token, id) => {
    var myAuthData = {
      id: id,
      access_token: token,
    };
    const loggedIn = await Parse.User.logInWith("linkedin", {
      authData: myAuthData,
    }).then((myObject) => {
      showImageHeader(true);
      navigate("/Dashboard");
    });

    return loggedIn;
  };

  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");

  const [eEmail, setEEmail] = useState(false);
  const [ePassword, setEPassword] = useState(false);

  const [show, setShow] = useState(false);
  const handleClick = () => setShow(!show);

  const [wrong, setWrong] = useState(false);

  const navigate = useNavigate();

  const handleChangePassword = (e) => {
    e.preventDefault();
    let canSubmit = true;

    setEEmail(false);
    setEPassword(false);
    setWrong(false);

    if (email) {
      if (email.length === 0) {
        setEEmail(true);
        canSubmit = false;
      }
    } else {
      setEEmail(true);
      canSubmit = false;
    }
    console.log(email);

    if (canSubmit) {
      Parse.User.requestPasswordReset(email)
        .then(() => {
          toast({
            title: "CHANGER LE MOT DE PASSE",
            description: "Un email vous a été envoyé",
            status: "success",
            duration: 3000,
            isClosable: true,
          });
        })
        .catch((error) => {
          setEEmail(true);
          alert("Error: " + error.code + " " + error.message);
          console.log("Error: " + error.code + " " + error.message);
        });
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    let canSubmit = true;

    setEEmail(false);
    setEPassword(false);
    setWrong(false);

    if (email) {
      if (email.length === 0) {
        setEEmail(true);
        canSubmit = false;
      }
    } else {
      setEEmail(true);
      canSubmit = false;
    }
    if (password) {
      if (password.length === 0) {
        setEPassword(true);
        canSubmit = false;
      }
    } else {
      setEPassword(true);
      canSubmit = false;
    }

    if (canSubmit) {
      const user = await Parse.User.logIn(email, password).then(
        (myObject) => {
          if (myObject && myObject.get("type") === "recruteur") {
            showImageHeader(true);
            navigate("/Dashboard");
          } else {
            console.log(myObject);
          }
        },
        (error) => {
          setWrong(true);
          setEEmail(true);
          setEPassword(true);
        }
      );
    }
  };
  document.body.style = "background: #0080FF;";

  useEffect(() => {
    // logout
    // Parse.User.logOut().then(() => {
    //     const currentUser = Parse.User.current();
    //   });

    const token = new URLSearchParams(search).get("token");

    const id = new URLSearchParams(search).get("id");
    if (id && token) {
      onclick(token, id);
    }
    const currentUser = Parse.User.current();
    console.log(currentUser);
    if (currentUser && currentUser.get("type") === "recruteur") {
      navigate("/Dashboard");
    }
  }, []);

  return (
    <Box>
      <Box className={"container"}>
        <Center>
          <Box
            bg={"#D4EEFF"}
            py={[10, 10, 68, 68]}
            px={[2, 2, 44, 44]}
            borderRadius={40}
            style={{ zIndex: "30" }}
          >
            <Center>
              <Text
                fontFamily={"Sofia Pro"}
                fontSize="3xl"
                fontWeight="bold"
                color="black"
                marginBottom="10px"
              >
                Connectez-vous
              </Text>
            </Center>
            <Center>
              <Text
                fontFamily={"Sofia Pro"}
                fontSize="md"
                color="black"
                marginBottom="25px"
              >
                Heureux de vous revoir !
              </Text>
            </Center>
            <form onSubmit={handleSubmit}>
              <FormControl isInvalid={eEmail}>
                <InputGroup>
                  <InputLeftElement />
                  <Input
                    width={[300, 300, 387, 387]}
                    type="email"
                    placeholder="Email"
                    background="white"
                    color="black"
                    marginBottom="14px"
                    borderRadius={25}
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                  />
                </InputGroup>
                <FormErrorMessage>
                  {eEmail ? "Veuillez entrer un email valide" : ""}
                </FormErrorMessage>
              </FormControl>
              <FormControl isInvalid={ePassword}>
                <InputGroup>
                  <InputLeftElement />
                  <Input
                    width={[300, 300, 387, 387]}
                    type="password"
                    placeholder="Mot de passe"
                    background="white"
                    color="black"
                    marginBottom="17px"
                    borderRadius={25}
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                  />
                </InputGroup>
                <FormErrorMessage>
                  {ePassword ? "Veuillez entrer un mot de passe valide" : ""}
                </FormErrorMessage>
              </FormControl>
              <Center>
                <Button
                  fontFamily={"Sofia Pro"}
                  color="black"
                  fontWeight="bold"
                  fontSize="md"
                  bg={"#D4EEFF"}
                  marginBottom="25px"
                  onClick={handleChangePassword}
                  className="changeButton"
                >
                  Mot de passe oublié
                </Button>
              </Center>
              <Center>
                <Button
                  className="btn_save"
                  type="submit"
                  errorBorderColor="red.300"
                  color={"white"}
                  borderRadius={25}
                  background={"#F1404B"}
                  px={30}
                  onSubmit={handleSubmit}
                >
                  Valider
                </Button>
              </Center>
            </form>
          </Box>
        </Center>
      </Box>
      <Image
        display={["block", "block", "none", "none"]}
        w={205}
        h={205}
        src={earth}
        marginStart={"25px"}
        style={{ marginTop: "-215%" }}
      />
      <Image
        display={["block", "block", "none", "none"]}
        w={205}
        h={205}
        src={fuse}
        marginStart={"175px"}
        style={{ marginTop: "115%" }}
      />
    </Box>
  );
}

export default ConnexionPage;
